import { useState } from "react";
import { getFileTypeIcon, isImageContentType } from "../utils/getFileTypeIcon";

type FileThumbnailProps = {
  src?: string | null;
  contentType?: string | null;
  name?: string | null;
  size?: number;
};

export function FileThumbnail({ src, contentType, name, size = 32 }: FileThumbnailProps) {
  const [failedSrc, setFailedSrc] = useState<string | null>(null);
  const imageLoadFailed = failedSrc !== null && failedSrc === src;

  if (isImageContentType(contentType) && src && !imageLoadFailed) {
    return (
      <img
        src={src}
        alt={name ?? ""}
        onError={() => setFailedSrc(src)}
        style={{
          width: size,
          height: size,
          objectFit: "cover",
          borderRadius: "var(--ant-border-radius)",
          flexShrink: 0,
        }}
      />
    );
  }

  return (
    <span
      style={{
        color: "var(--ant-color-text-secondary)",
        fontSize: Math.round(size * 0.6),
        flexShrink: 0,
      }}
    >
      {getFileTypeIcon({ contentType, name })}
    </span>
  );
}
